const addressObjectToString = ({ address, line1, city, state, zip }) =>
  `${address ? address : line1}, ${city}, ${state} ${zip}`

export default addressObjectToString
